module.exports = __webpack_public_path__ + "static/media/faqs.a1ed8821.svg";